// extracted by css-extract-rspack-plugin
export default {"container":"_31m-X-IX4GaVHRGblvAxP"};